// @flow
import { reset as resetForm } from "redux-form";
import {
    EVENT_CREATE_ERROR,
    EVENT_CREATE_LOADING,
    EVENT_CREATE_SUCCESS,
    EVENT_CREATE_REQUESTED,
} from "../actions/constants";
import type {
    EventCreateErrorAction,
    EventCreateLoadingAction,
    EventCreateSuccessAction,
    EventCreateRequestedAction,
} from "./actions.types";
import type { FormType } from "./types";

export function error(error: any): EventCreateErrorAction {
    return { type: EVENT_CREATE_ERROR, payload: error };
}

export function loading(loading: any): EventCreateLoadingAction {
    return { type: EVENT_CREATE_LOADING, payload: loading };
}

export function reset() {
    return (dispatch: Function) => {
        dispatch(resetForm("event"));
        dispatch(loading(false));
        dispatch(error(null));
    };
}

export function success(created: Object): EventCreateSuccessAction {
    reset();

    return { type: EVENT_CREATE_SUCCESS, payload: created };
}

type Promise = {
    values: FormType,
    reject: Function,
    resolve: Function,
};

export function create(values: Promise): EventCreateRequestedAction {
    return { type: EVENT_CREATE_REQUESTED, payload: values };
}
